module.exports = __webpack_public_path__ + "static/img/del.afd78387.svg";